export default function styles() {
    return {
        position: 'absolute' as 'absolute'
    }
}